export default __webpack_public_path__ + "static/787-2728e74030e45b9b0246172ba91fc9b8.gif";